import React, { memo, useCallback, useEffect, useState } from "react";
import "./RVParksList.css";
import { Col } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ArrowUp from "@mui/icons-material/ArrowUpward";
import ArrowDown from "@mui/icons-material/ArrowDownward";
import Profile from "../Profile/Profile";
import { Button, Snackbar } from "@mui/material"; 
import markerImg from "../../../../Assets/Images/orange-home.png";
import excel from '../../../../Assets/Images/excel.png';
import InfiniteScroll from "react-infinite-scroller";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import MarketProperty from "../../../HelperComponent/MarketProperty";
import ParentStreetView from "../../StoreStreetView/ParentStreetView";
import ConstantData from "../../../../Utils/Constant"; 
import { converJsonToExcel } from "../../../../helpers/excelHelper";
import { formatSeasonalityText } from "../../../../helpers/dataHelper";
import { Clear } from "@mui/icons-material";
import { apiCommonTrigger, apiCommonTriggerBlob } from "../../../../Utils/apiServicehelper";
import { Config } from "../../../../Utils/Config";

let listOfParks = [];
let rv_parklist = [];
const RVParksList = memo((props) => {
  const apiPath = process.env.REACT_APP_API_URL;
  const [isLoading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const marketId = location.pathname.split("/").pop();
  const [rvDataList, setRvDataList] = useState({});
  const [profile, setProfile] = useState({ showProfile: false });
  const [profileInfo, setProfileInfo] = useState({});
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [orderBy, setOrderBy] = useState("proximity");
  const [orderDirection, setOrderDirection] = useState(true);
  const[isProfile, setIsProfile] = useState(true);
  const[isProximity,setIsProximity] = useState(true);
  const[isFacility,setIsFacility] = useState(true);
  const [totalPage, setTotalPage] = useState(0);
  const [isModal , setSetModal] = useState(false);
  const [selectedData , setSelectedData] = useState({latitude : null , longitude : null , profilename : "" });
  const [snack, setSnackOpen] = useState({ snackOpen: false, snackMsg: "" });
  //show market profile popup
  const toggleProfile = useCallback(
    (show) => {
      if (show) {
        setProfile((prev) => {
          return {
            ...prev,
            showProfile: show,
          };
        });
      } else {
        setProfile({
          ...profile,
          showProfile: false,
        });
      }
    },
    [profile.showProfile]
  );

  //get interactive map data
  const getMarketData = async () => {
    setLoading(true);
     let inputData={ page: page,
        resultsPerPage: rowsPerPage,
        orderBy: orderBy,
        orderDirection: orderDirection ? "Asc" : "Desc",
        marketId: marketId,
        forDownload: false,}
        
    await apiCommonTrigger("post",`${Config.API_URL}/markets/market/rvparks`,inputData).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        if (page === 1) {
          listOfParks = [];
          rv_parklist = [];
          setRvDataList({});
        }
        listOfParks.push(res.data.rvParks);
        rv_parklist = listOfParks.filter(e => e.length);
        setTotalPage(res.data.pagination?.totalpages);
        setRvDataList({ rv_parklist });
      }else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  //remove duplicates from list 
  useEffect(() => {
    listOfParks = [];
    rv_parklist = [];
  }, []);

  useEffect(() => {
    if (Object.keys(props.data).length === 0) {
      props.getBasicDetails(props.marketId);
    }
  }, [props.data, props.marketId])
  
  const downloadData = () => {
    let inputData={ orderBy: orderBy,
        orderDirection: orderDirection ? "Asc" : "Desc",
        marketId: marketId,
        forDownload: true,}
     apiCommonTrigger("post",`${Config.API_URL}/markets/market/rvparks`,inputData)
   .then((res) => {
      if (res.status === 200) {
        const rvlist = res.data;
        converJsonToExcel(rvlist , "Rvparklist");         
      }else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };
  //get profile for selected pins
  const setSelectedInfo = (data) => {
    setProfileInfo({ ...profileInfo, profileInfo: data });
    setProfile({ ...profile, showProfile: true });
  };

  //move to next page of the records
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  //change the display rows per page in record
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleInfiniteOnLoad = () => {
    // if (page + 1 <= totalPage) {
    setPage(page + 1);
    // }

  }

  //call rvlist based on the below changes
  useEffect(() => {
    if (page === 1 || page <= totalPage) {
      getMarketData();
    }

  }, [page, orderDirection]);

  //price conversion
  const priceConversion = (tot) => {
    if (tot === null || tot === undefined)
      return null;

    if (tot !== "") {
      let checkDigit = tot.toString().split(".");
      let ret = "";
      let i = 0;
      if (tot.toString().indexOf(".") == -1) {
        tot = tot;
      } else {
        if (checkDigit == "00") {
          tot = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }
          }
          ret = ret.toString();
          tot = ret;
        }
      }
    }
    return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const trackModal =(bool) => {
      setSetModal(false);
  }
    //snack bar open/close
   const snackHandleclose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ ...snack, snackOpen: false, snackMsg: "" });
  };

  const handleDownloadParkProfile=(data)=>{   
    var timestamp = new Date().getDate() + "" + new Date().getMonth() + "" + new Date().getFullYear() + "" + new Date().getTime();
    var fileName =  "RVParkIQ_RVParksProfileDetail_" + timestamp + ".pdf"
    var alertMsg = "Your download is being processed. The " +
      fileName + 
      " file will be downloaded automatically to your browser when ready."
      setSnackOpen({
        ...snack,
        snackOpen: true,
        snackMsg: alertMsg,
      });

      const payload = {
        "profileId": data?.profileid,
        "latitude": data?.latitude,
        "longitude": data?.longitude,
        "fileName": fileName
      };
      
      apiCommonTriggerBlob("post",`${Config.API_URL}/rvParks/profile/download`, payload).then((res) => {
        if (res.status === 200) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        } else if (res.status === 401) {
          navigate("/");
        }
      })
      .catch((error) => {
        handlingCatchError(error, navigate);
      });  
  }

  return (
    <div>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
       <Snackbar
         anchorOrigin={{ vertical: "top", horizontal: "center" }}
         open={snack.snackOpen}
         id="snack-success"
         className="snack-bar custom-snackbar"
         maxsnack={3}
         autoHideDuration={5000}
         onClose={snackHandleclose}
         ContentProps={{"aria-describedby": "message-id",}}
         message={<span id="message-id">{snack.snackMsg}</span>}
         action={[
          <Clear
             key="close"
             aria-label="Close"
             color="inherit"
             onClick={snackHandleclose}
          />,
           ]}
         />
      <div className="common-table rvparks-list" >      
        {rv_parklist && rv_parklist.length > 0 ? <Button onClick={() => downloadData()} className="excel-download"> <img src={excel} alt="Excel Download" />Download</Button> : ""}
        <MarketProperty fromPage={"rv-list"} />
        <div className="clear"></div>
        <div className="table-design table-height">
          <InfiniteScroll
            initialLoad={false}
            loadMore={handleInfiniteOnLoad}
            hasMore={page !== totalPage}
            threshold={20}
            useWindow={false}
          >
            <Table>
              <TableHead>
                <TableRow >
                  <TableCell id="sort-amenities" onClick={() => {
                    rv_parklist = [];
                    setOrderDirection(!orderDirection);
                    setIsProfile(!isProfile)
                    setOrderBy("profilename");
                    setPage(1);
                  }}>
                    Profile Name {isProfile ? <ArrowDown /> : <ArrowUp />}
                  </TableCell>
                  <TableCell id="sort-amenities" onClick={() => {
                    rv_parklist = [];
                    setOrderDirection(!orderDirection);
                    setIsProximity(!isProximity)
                    setOrderBy("proximity");
                    setPage(1);
                  }}
                    >Proximity (miles) {isProximity ? <ArrowDown /> : <ArrowUp />}
                    </TableCell>
                  <TableCell id="sort-amenities" onClick={() => {
                    rv_parklist = [];
                    setOrderDirection(!orderDirection);
                    setIsFacility(!isFacility)
                    setOrderBy("facilitytypes");
                    setPage(1);
                  }}>
                    Facility Type {isFacility ? <ArrowDown /> : <ArrowUp />}
                  </TableCell>
                  <TableCell>No. of Spots</TableCell>
                  <TableCell>Seasonality</TableCell>
                  <Tooltip title="Average online review rating out of 5" placement="top" arrow>
                    <TableCell>Google Rating<InfoOutlined /></TableCell>
                  </Tooltip>
                  <TableCell>Online Booking</TableCell>
                  <TableCell>Has Glamping</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rvDataList && rvDataList.rv_parklist !== undefined && rvDataList.rv_parklist[0] !== undefined &&
                  rvDataList.rv_parklist[0].length > 0 ? (
                  rvDataList.rv_parklist.map(list => list.map((data) => (
                    <TableRow>
                      <TableCell>
                        {data.profilename ? data.profilename : "-"}
                        {data.ishome ?
                          <img
                            src={markerImg}
                            alt="Market Center"
                            height={15}
                            style={{marginLeft:`2px`}}
                          ></img>
                          : ''}
                        <br />
                        <span>
                          {[ data.streetaddress1, data.streetaddress2, data.city, data.statecode, data.zipcode ].filter(Boolean).join(", ")}
                        </span>
                      </TableCell>
                      <TableCell>
                        {data.proximity && data.proximity !== undefined ? priceConversion(data.proximity) === "0.00" ? '-' : priceConversion(data.proximity) : "-"}
                      </TableCell>
                      <TableCell>
                        {data.facilitytypes ? data.facilitytypes : "-"}
                      </TableCell>
                    < TableCell >
                    { data.noofsites ? data.noofsites : "-" }
                      </TableCell>
              <TableCell>
                {data.seasonalityname ? formatSeasonalityText(data.seasonalityname) : "-"}
              </TableCell>
              <TableCell>
                {data.rating ? data.rating : "-"}
              </TableCell>
              <TableCell>
                {data.onlinebookingstatus ? data.onlinebookingstatus : "-"}
              </TableCell>

              <TableCell>
                {data.glamping ? data.glamping : "-"}
              </TableCell>

              <TableCell>
                {
                  <a href="#" onClick={() =>  { setSelectedData(data); setSetModal(true); }} >  
                      See street view
                  </a>
                }
                {data.website ? (
                  <a href={"http://" + data.website} target="new">
                    Go to website
                  </a>
                ) : (
                  ""
                )}
                {
                  <a href="#" onClick={() => setSelectedInfo(data)} >
                    View Profile
                  </a>
                }
                   <a href="#" style={{width:"fit-content"}} onClick={() => handleDownloadParkProfile(data)} >
                    Download Profile
                  </a>
              </TableCell>
            </TableRow>
            )))
            ) : isLoading ? (
            ""
            ) : (
            <TableRow>
              <TableCell
                style={{ textAlign: "center" }}
                colSpan="8"
                className="store-no-data"
              >
                No records found
              </TableCell>
            </TableRow>
                )}
          </TableBody>

        </Table>
      </InfiniteScroll>
    </div>

        {/* </div> */ }
  <div>
    {profile.showProfile && profileInfo && profileInfo.profileInfo ? (
      <Col>
        <Profile
          profileData={profileInfo}
          toggleProfile={toggleProfile}
          isFrom="rv-list"
        />
      </Col>
    ) : null}
  </div>

      </div>
          {ParentStreetView(isModal , trackModal , selectedData.profilename , {lat : selectedData.latitude, long : selectedData.longitude } )}
    </div>
  );
});

export default RVParksList;